import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import lang from 'lang'
import CommonLayout from 'components/common-layout'
import Head from 'components/head'
import withAuthPageHOC from 'components/auth-page-hoc'
import { isUser } from 'common/utils/determine-user'
import HeroSection from 'common/components/hero-section'
import Nudges from 'page-modules/roadmap/nudges'

@withAuthPageHOC
@connect((state) => ({
  user: state.root.user,
}))
export default class Roadmap extends React.Component {
  static propTypes = {
    user: PropTypes.object,
  }

  get canSeeAssignments() {
    return isUser.schoolImplementationTeam(this.props.user)
  }

  get subtitleSlug() {
    return this.canSeeAssignments
      ? 'dashboard/roadmap-description/impl'
      : 'dashboard/roadmap-description/staff'
  }

  render() {
    return (
      <CommonLayout>
        <Head title={lang.page.roadmap.headTitle} />
        <div className="roadmap">
          <HeroSection titleSlug="dashboard/roadmap-title" subtitleSlug={this.subtitleSlug} />
          <div className="grid-container margin-top-3">
            <div className="grid-x grid-padding-x">
              <div className="small-12 medium-10 cell medium-offset-1">
                <Nudges />
              </div>
            </div>
          </div>
        </div>
      </CommonLayout>
    )
  }
}
